import { FormValues } from '../types/sourceDetailFormValues';

import {
  Core,
  Bng,
  Hmm,
  Conductor,
  EnumDKeySourceType,
} from '../../../../types/generated-types';

export const calculateSourceFormValues = (
  source: Partial<Core | Bng | Hmm | Conductor> | undefined,
) => {
  const initialValues: FormValues = {
    ...(source
      ? {
          name: source.name ?? '',
          type: source.type ?? '',
          url: source.url ?? '',
          localUrl:
            source.__typename === EnumDKeySourceType.Bng
              ? source.localUrl
                ? source.localUrl
                : ''
              : '',
          temperature:
            source.__typename === EnumDKeySourceType.Hmm ||
            source.__typename === EnumDKeySourceType.Conductor ||
            source.__typename === EnumDKeySourceType.Core
              ? (source.tolerances?.temperature?.toString() ?? '')
              : '',
          humidity:
            source.__typename === EnumDKeySourceType.Core ||
            source.__typename === EnumDKeySourceType.Conductor
              ? (source.tolerances?.humidity?.toString() ?? '')
              : '',
          voltage:
            source.__typename === EnumDKeySourceType.Core
              ? (source.tolerances?.voltage?.toString() ?? '')
              : '',
          maxReportingTime:
            source.__typename === EnumDKeySourceType.Hmm ||
            source.__typename === EnumDKeySourceType.Conductor ||
            source.__typename === EnumDKeySourceType.Core
              ? (source.maxReportingTime?.toString() ?? '')
              : '',
          propertyId: source.propertyId ?? '',
          buildingId:
            source.__typename === EnumDKeySourceType.Conductor
              ? ((source as Conductor & { buildingId?: string }).buildingId ??
                '')
              : '',
        }
      : {
          name: '',
          type: '',
          url: '',
          localUrl: '',
          temperature: '',
          humidity: '',
          voltage: '',
          maxReportingTime: '',
          propertyId: '',
          buildingId: '',
        }),
  };
  return initialValues;
};
